import { Component } from '@angular/core';
import { faCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-view-chords',
  templateUrl: './Chords.html',
  styleUrls: ['./style.css']
})
export class AppViewChords {
  public fa = {
    checked: faCheckCircle,
    unchecked: faCircle,
  };

  public extras = [
    { title: 'sus2', value: 'sus2' },
    { title: 'sus4', value: 'sus4' },
    { title: '5', value: '5' },
    { title: '6/9', value: '6_9' },
    { title: '6', value: '6' },
    { title: '7', value: '7' },
    { title: 'maj7', value: 'maj7' },
    // { title: '8', value: '8' },
    { title: '9', value: '9' },
    { title: 'add9', value: 'add9' },
    { title: 'maj9', value: 'maj9' },
    { title: '10', value: '10' },
    { title: '11', value: '11' },
    // { title: '12', value: '12' },
    { title: '13', value: '13' },
  ];

  public show = {
    half: false,
    maj: true,
    min: false,
    guitar: true,
    ukulele: true
  }

  public extra = {
    guitar: {
      maj: '5',
      min: '5',
    },
    ukulele: {
      maj: '5',
      min: '5',
    }
  };

  private _notes = {
    "all": ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'],
    "white": ['C', 'D', 'E', 'F', 'G', 'A', 'B'],
  };

  public get notes(): string[] {
    if (!this.show.half) {
      return this._notes.white;
    }
    return this._notes.all;
  }
}
